import React from "react"
import { graphql } from "gatsby"
import { getSrc } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import ProductView from "../../views/ProductView"
import { useMenuState } from "../../lib/hooks"

const ProductPage = ({ data, location }) => {
  const model = data.strapiPage
  const product = data.strapiProduct
  const [menu_state, on_menu_button_click] = useMenuState()

  return (
    <Layout on_menu_button_click={on_menu_button_click} >
      <Seo title={product.Name} description={product.Brand + ' ' + product.Name + ' We can help you with bulk orders. Call now!'} image={getSrc(product.Photo[0].localFile)} slug={"products/" + product.strapiId} />
      <ProductView model={model} product={product} menu_state={menu_state} />
    </Layout>
  )
}

export default ProductPage

export const query = graphql`
  query($strapiId: Int) {
    strapiPage(strapiId: {eq: 5}) {
      Body
      lottiefile
      name
      panel {
        TextAlign
        body
        color
        lottiefile
        name
        id
      }
      panels {
        TextAlign
        body
        color
        images {
          alternativeText
          caption
          height
          name
          width
          url
        }
        lottiefile
        name
      }
      photo {
        alternativeText
        caption
        height
        name
        url
        width
      }
    }
    strapiProduct(strapiId: {eq: $strapiId}) {
      Brand
      Description
      Name
      Photo {
        alternativeText
        caption
        height
        url
        width
        name
        localFile {
          childImageSharp {
            gatsbyImageData(width: 600)
          }
        }
      }
      Price
      SKU
      Size
      categories {
        name
      }
      strapiId
      products_items {
        Item
        Leadtime
        Price
        SKU
      }
      sellsheet {
        alternativeText
        caption
        name
        url
      }
    }
  }
`
